module.exports = function getResource(label) {
    const resources = {
        popularNow: 'POPULAR NOW!',
        popular: 'POPULAR!',
        peopleViewed: 'people recently viewed this.',
        recentViews: 'recent views.'
    };

    return resources[label];
};
